import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";
import "./LatestUpdates.css";

const LatestUpdates = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await API.get("/latest/latest-updates");
        setItems(res.data.data || []);
      } catch (err) {
        console.error("Latest updates load error:", err);
      }
    })();
  }, []);

  if (!items || items.length === 0) return null;

  const colors = [
    "latest-orange",
    "latest-blue",
    "latest-pink",
    "latest-purple",
    "latest-green",
    "latest-red"
  ];

  const renderItems = (list) =>
    list.map((item, i) => {
      const colorClass = colors[i % colors.length];

      return (
        <p key={`${item._id || i}-${Math.random()}`} className={`latest-list-item ${colorClass}`}>
          <i className="bi bi-caret-right-fill"></i>
          <Link
            to={`/category/${encodeURIComponent(item.categoryName)}`}
            className="latest-link"
            onClick={(e) => e.stopPropagation()}
          >
            {item.categoryName} → {item.subcategoryName}
          </Link>
          <span className="new-badge ms-2">NEW</span>
        </p>
      );
    });

  return (
    <div
      className="scheme-card card h-100 shadow-sm"
      onClick={() => (window.location.href = "/latest-updates")}
      style={{ cursor: "pointer" }}
    >
      <div className="card-body">
        <h5 className="scheme-card-title mb-3">
          <Link
            to="/latest-updates"
            className="scheme-card-title"
            onClick={(e) => e.stopPropagation()}
          >
            🔥 Latest Updates
          </Link>
        </h5>

        <div className="auto-scroll-wrapper">
          <div className="auto-scroll-content">
            {/* Original list */}
            {renderItems(items)}

            {/* Duplicate list for seamless infinite loop */}
            {renderItems(items)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestUpdates;
